import { ThemeProvider } from 'styled-components';
import { AppRouter } from "./routes";
import { AuthProvider } from "./services/contexts/auth";
import { ToastProvider } from "./services/contexts/toast";
import Toast from "./components/Toast";
import GlobalStyles from "./styles/GlobalStyles";
import theme from "./styles/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ToastProvider>
        <Toast />
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
